import type { RoleAction } from '@wix/members-domain-ts';
import type { FC } from 'react';
import React from 'react';

import type { AdditionalAction, Position } from '../../../types';
import { DataHook } from '../../../types';
import MoreButton from '../MoreButton';
import type { OnAdditionalAction, OnRoleAction } from './PopoverContent';

interface MemberMoreButtonProps {
  containerClass: string;
  additionalActions: AdditionalAction[];
  rolesActions: RoleAction[];
  alignment: Position;
  isMobile: boolean;
  isRtlLocale: boolean;
  isDisabled?: boolean;
  onAdditionalAction: OnAdditionalAction;
  onRoleAction: OnRoleAction;
}

const MemberMoreButton: FC<React.PropsWithChildren<MemberMoreButtonProps>> = ({
  containerClass,
  additionalActions,
  rolesActions,
  alignment,
  isMobile,
  isRtlLocale,
  isDisabled,
  onAdditionalAction,
  onRoleAction,
}) => {
  if (!rolesActions.length && !additionalActions.length) {
    return null;
  }

  return (
    <div data-hook={DataHook.MoreActionsWrapper} className={containerClass}>
      <MoreButton
        alignment={alignment}
        isRtlLocale={isRtlLocale}
        isMobile={isMobile}
        isDisabled={isDisabled}
        additionalActions={additionalActions}
        rolesActions={rolesActions}
        onAdditionalAction={onAdditionalAction}
        onRoleAction={onRoleAction}
      />
    </div>
  );
};

export default MemberMoreButton;
